import { createContext, useEffect, useState } from "react";

interface IToggles {
  [key: string]: boolean;
}

interface IApplicationContext {
  toggles?: IToggles;
  togglesLoading: boolean;
  togglesError?: Error;
}

const environment = process.env.REACT_APP_DEPLOY_ENV || "development";

export const ApplicationContext = createContext<IApplicationContext>({
  togglesLoading: true,
});

export const useApplicationConfig = () => {
  const [configValue, setConfigValue] = useState<IApplicationContext>({
    togglesLoading: true,
  });

  useEffect(() => {
    fetch(
      `https://laborhack-feature-toggles.s3.amazonaws.com/toggles/${environment}.json`
    )
      .then((response) => response.json())
      .then((data) => {
        setConfigValue((prevState) => ({
          ...prevState,
          toggles: data,
          togglesLoading: false,
        }));
      })
      .catch((error) => {
        setConfigValue((prevState) => ({
          ...prevState,
          togglesLoading: false,
          togglesError: error instanceof Error ? error : new Error("Feature toggles failed"),
        }));
      });
  }, []);

  return configValue;
};
